export default function declareImageOverlay() {
	class USGSOverlay extends google.maps.OverlayView {
		rotation: number;
		opacity: number;
		div_: HTMLDivElement | null;
		bounds_: google.maps.LatLngBounds;
		image_: string;
		img_: HTMLImageElement | undefined;

		constructor(bounds: google.maps.LatLngBounds, image: string, rotation: number, opacity: number) {
			super(); // Initialize all properties.

			// @ts-ignore
			this.bounds_ = bounds;
			// @ts-ignore
			this.image_ = image; // Define a property to hold the image's div. We'll
			// actually create this div upon receipt of the onAdd()
			// method so we'll leave it null for now.

			this.div_ = null;

			this.rotation = rotation;
			// this.rotation = 0;
			this.opacity = opacity;
		}

		updateImage(image: string) {
			if (this.image_ === image) return;
			this.image_ = image;
			if (this.img_) this.img_.src = this.image_;
		}

		/**
		 * onAdd is called when the map's panes are ready and the overlay has been
		 * added to the map.
		 */

		onAdd() {
			this.div_ = document.createElement("div");
			this.div_.style.borderStyle = "none";
			this.div_.style.borderWidth = "0px";
			this.div_.style.position = "absolute"; // Create the img element and attach it to the div.
			this.div_.id = "image-overlay";
			this.div_.style.border = "1px, solid, #f00";

			this.img_ = document.createElement("img");
			this.img_.src = this.image_;
			this.img_.style.width = "100%";
			this.img_.style.height = "100%";
			this.img_.style.opacity = this.opacity.toString();
			// img.style.transform = "translate(-50%, -50%);";
			this.div_.appendChild(this.img_); // Add the element to the "overlayLayer" pane.

			const panes = this.getPanes();
			// @ts-ignore
			panes.overlayLayer.appendChild(this.div_);
		}

		draw() {
			// We use the south-west and north-east
			// coordinates of the overlay to peg it to the correct position and size.
			// To do this, we need to retrieve the projection from the overlay.
			const overlayProjection = this.getProjection(); // Retrieve the south-west and north-east coordinates of this overlay
			// in LatLngs and convert them to pixel coordinates.
			// We'll use these coordinates to resize the div.

			const sw = overlayProjection.fromLatLngToDivPixel(
				this.bounds_.getSouthWest()
			);
			const ne = overlayProjection.fromLatLngToDivPixel(
				this.bounds_.getNorthEast()
			); // Resize the image's div to fit the indicated dimensions.

			if (this.div_) {
				// @ts-ignore
				this.div_.style.left = sw.x + "px";
				// @ts-ignore
				this.div_.style.top = ne.y + "px";
				// @ts-ignore
				this.div_.style.width = ne.x - sw.x + "px";
				// @ts-ignore
				this.div_.style.height = sw.y - ne.y + "px";
				this.div_.style.transform = "rotate("+this.rotation+"deg)";
			}
		}
	}

	return USGSOverlay;
}
